import { OrganisationUser } from './API'

/**
 * Dashboard Configuration types for OrganisationUser
 */

export interface DashboardDateRange {
  type: 'relative' | 'absolute'
  startDaysFromToday?: number | null
  endDaysFromToday?: number | null
  startDate?: string | null
  endDate?: string | null
}

export interface DashboardFilters {
  selectedCompanyFilter: string[]
  selectedSectorFilter: string[]
  selectedConsultantFilter: string[]
  selectedStatusFilter: string[]
  dateRange: DashboardDateRange
  searchText: string
}

export interface FilterState {
  selectedCompanyFilter: string[]
  selectedSectorFilter: string[]
  selectedConsultantFilter: string[]
  selectedStatusFilter: string[]
  startDate: string | null
  endDate: string | null
  searchText: string
}

export interface TableOptionsState {
  itemsPerPage: number
  sortBy: string[]
  sortDesc: boolean[]
}

export interface DashboardTableOptions {
  itemsPerPage: number
  sortBy: string[]
  sortDesc: boolean[]
}

export interface DashboardConfiguration {
  filters: DashboardFilters
  tableOptions: DashboardTableOptions
}

/**
 * Extended OrganisationUser type that includes fields stored in DynamoDB but not exposed via GraphQL.
 * Use this type when working with OrganisationUser records from direct DynamoDB access.
 */
export interface PlatformOrganisationUser extends OrganisationUser {
  /** Dashboard configuration stored in DynamoDB but not exposed via GraphQL for security */
  dashboardConfiguration?: DashboardConfiguration
}

/**
 * Default dashboard configuration values
 * Used when user has no saved configuration
 */
export const DEFAULT_DASHBOARD_CONFIGURATION: DashboardConfiguration = {
  filters: {
    selectedCompanyFilter: [],
    selectedSectorFilter: [],
    selectedConsultantFilter: [],
    selectedStatusFilter: ['Released', 'Completed'],
    dateRange: {
      type: 'relative',
      startDaysFromToday: -90, // 3 months ago
      endDaysFromToday: 0 // today
    },
    searchText: ''
  },
  tableOptions: {
    itemsPerPage: 25,
    sortBy: ['date'],
    sortDesc: [true]
  }
}
